var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 15.8333V4.16666C3.3335 2.78583 4.45266 1.66666 5.8335 1.66666H11.6668L16.6668 6.66666V15.8333C16.6668 17.2142 15.5477 18.3333 14.1668 18.3333H5.8335C4.45266 18.3333 3.3335 17.2142 3.3335 15.8333Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 5V1.66666L16.6665 6.66666H13.3332C12.4123 6.66666 11.6665 5.92083 11.6665 5Z",
    fill: "#6C6C6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 10.8333H7.49984C7.039 10.8333 6.6665 10.46 6.6665 10C6.6665 9.54 7.039 9.16666 7.49984 9.16666H12.4998C12.9607 9.16666 13.3332 9.54 13.3332 10C13.3332 10.46 12.9607 10.8333 12.4998 10.8333Z",
    fill: "#6C6C6C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8332 14.1667H7.49984C7.039 14.1667 6.6665 13.7933 6.6665 13.3333C6.6665 12.8733 7.039 12.5 7.49984 12.5H10.8332C11.294 12.5 11.6665 12.8733 11.6665 13.3333C11.6665 13.7933 11.294 14.1667 10.8332 14.1667Z",
    fill: "#6C6C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentSmall);
export default __webpack_public_path__ + "static/media/document-small.f42fb884dafac5304e534cf0d418fa8c.svg";
export { ForwardRef as ReactComponent };